import { useQuery } from "@tanstack/react-query";
import { api } from "services/api.service";
import useAuth from "./useAuth";

export default function useFeatureFlag(name: string) {
  const { loggedIn } = useAuth();
  const { data: enabled } = useQuery({
    queryKey: ["feature_flag", name],
    queryFn: () =>
      api
        .get<{ enabled: boolean }>(`/feature_flags/${name}`)
        .then(({ data }) => data.enabled)
        .catch(() => false),
    enabled: Boolean(name && loggedIn),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  return { enabled, loading: enabled === undefined };
}
